import { getFirebaseAuth } from '../config/firebase';
import { getCurrentUserId } from './firestoreService';


const getToken = async () => {
  const auth = await getFirebaseAuth();
  if (!auth.currentUser) {

    return null;
  }
  return await auth.currentUser.getIdToken(true); // Force refresh token
};

export async function upsertCanvas(userId, canvasId, canvasData) {
  const token = await getToken();
  if (!token) {
    throw new Error("User not authenticated");
  }

  try {
    // Use appropriate API URL based on environment
    const url = import.meta.env.PROD 
      ? 'https://youcreate-app-498148088233.australia-southeast2.run.app/api/canvases/upsert'
      : `${window.location.protocol}//${window.location.host}/api/canvases/upsert`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        canvasId,
        data: canvasData
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to save canvas');
    }

    return await response.json();
  } catch (error) {

    throw error;
  }
}

export async function getUserCanvases(userId = null) {
  const token = await getToken();
  if (!token) {
    throw new Error("User not authenticated");
  }

  try {
    const response = await fetch('/api/canvases/canvases', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch canvases');
    }

    const canvases = await response.json();
    return canvases; // Backend already returns array of canvases
  } catch (error) {

    throw error;
  }
}

export async function deleteCanvas(userId, canvasId) {
  const token = await getToken();
  if (!token) {
    throw new Error("User not authenticated");
  }

  try {
    const response = await fetch('/api/canvases/delete-canvas', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        canvasId
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to delete canvas');
    }

    return await response.json();
  } catch (error) {

    throw error;
  }
}

export async function updateCanvasName(userId, canvasId, newName) {
  const token = await getToken();
  if (!token) {
    throw new Error("User not authenticated");
  }

  try {
    const response = await fetch('/api/canvases/canvases/name', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        canvasId,
        newName
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to update canvas name');
    }

    return await response.json();
  } catch (error) {

    throw error;
  }
}

export async function duplicateCanvas(userId, sourceCanvasId) {
  const token = await getToken();
  if (!token) {
    throw new Error("User not authenticated");
  }

  try {
    const response = await fetch('/api/canvases/duplicate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        canvasId: sourceCanvasId
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to duplicate canvas');
    }

    return await response.json();
  } catch (error) {

    throw error;
  }
}